import { getLanguageParam } from '@sportal365/smp-widget-utils';
import { IBasketballCompetitionResponseV2, IBasketballSeasonsResponseV2, ISeasonV2, SDKOptions } from '../../types';
import { generateRequest } from '../http.service';

export const getCompetition = async ({
  competition_id,
  sdkOptions,
}: {
  competition_id: string;
  sdkOptions: SDKOptions;
}): Promise<IBasketballCompetitionResponseV2> => {
  const url = `${sdkOptions.dataConfigApiUrl}/competitions/${competition_id}`;

  const baseParams = {
    translation_language: getLanguageParam(sdkOptions.dataConfigLang),
  };

  return await generateRequest(url, baseParams, sdkOptions);
};

export interface ISeasonsProps {
  team_id?: string;
  competition_id?: string;
}

export const getSeasons = async ({
  params,
  sdkOptions,
}: {
  params: ISeasonsProps;
  sdkOptions: SDKOptions;
}): Promise<IBasketballSeasonsResponseV2> => {
  const url = `${sdkOptions.dataConfigApiUrl}/seasons`;

  const baseParams = {
    translation_language: getLanguageParam(sdkOptions.dataConfigLang),
    competition_id: params.competition_id,
    team_id: params.team_id,
    offset: 0,
    limit: 200,
  };

  return await generateRequest(url, baseParams, sdkOptions);
};

export const getActiveSeason = async ({ season_id, sdkOptions }: { season_id: string; sdkOptions: SDKOptions }): Promise<ISeasonV2> => {
  const url = `${sdkOptions.dataConfigApiUrl}/seasons/details`;

  const baseParams = {
    translation_language: getLanguageParam(sdkOptions.dataConfigLang),
    season_id: season_id,
  };

  return await generateRequest(url, baseParams, sdkOptions);
};
